"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AlertActions;
(function (AlertActions) {
    AlertActions["Shown"] = "Shown";
    AlertActions["Hidden"] = "Hidden";
})(AlertActions || (AlertActions = {}));
exports.default = AlertActions;
